module.exports = __webpack_public_path__ + "static/logo-vodafone-ecc9606c7297482b9b664adc0c990b37.png";